export const conversations = (pageNumber: string) => {
    return `/api/convos?pageNumber=${pageNumber}`;
};
  
export const conversationById = (id: string) => {
    return `/api/convos/${id}`;
};